<div class="row">
  <div class="col-12" *ngIf="funciones && funciones.length !== 0">
    <nb-card class="row mb-0">
      <nb-card-body class="bg-secondary">
        <div class="row">
          <div class="col-4" *ngFor="let funcion of funciones">
            <!-- <div class="form-group"> -->
            <!-- <input type="checkbox" [checked]="funcion.checked" class="form-control" [(ngModel)]="funcion.checked"
                (change)="agregarSacarFuncion(funcion)">
              <span>{{funcion.display}}</span> -->

            <mat-checkbox [checked]="funcion.checked" [(ngModel)]="funcion.checked"
              (change)="agregarSacarFuncion(funcion)">{{funcion.nombre}}</mat-checkbox>
            <!-- </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-auto">
            <button class="btn btn-secondary" (click)="limpiarFunciones()">Destildar todo</button>
          </div>
          <div class="col-auto">
            <button class="btn btn-primary" (click)="cocinarFunciones()">Cocinar</button>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>